module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_electronically-controlled-management-system.beb8e16e.png";